<template>
    <div class="card">
        <TabView @tab-change="handleTabChange">
            <TabPanel header="จัดกลุ่มตามช่วงเวลา">
                <statistic-location-range-time></statistic-location-range-time>
            </TabPanel>
			<TabPanel header="จัดกลุ่มตามพื้นที่เกิดเหตุ">
				<statistic-location-event></statistic-location-event>
            </TabPanel>
            <TabPanel header="เปรียบเทียบสถิติเดือนเดียวกันในแต่ละปี">
                <statistic-location-year></statistic-location-year>
            </TabPanel>
        </TabView>
    </div>
</template>

<script>
import statisticLocationRangeTime from './StatisticLocationRangeTime';
import statisticLocationEvent from './StatisticLocationEvent';
import statisticLocationYear from './StatisticLocationYear';

export default {
    components: {
		statisticLocationRangeTime,
		statisticLocationEvent,
        statisticLocationYear
    },
    data() {
      return{
          
      }    
    },

    watch:{

    },

    mounted(){
    },

    methods: {
        handleTabChange(newTab){
            console.log(newTab.tab.$vnode.componentOptions.propsData.header)
        }
    }
}
</script>